import { render, staticRenderFns } from "./RequestProfileDataButton.vue?vue&type=template&id=cb423e0c"
import script from "./RequestProfileDataButton.vue?vue&type=script&lang=js"
export * from "./RequestProfileDataButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports